import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'group-icon',
  templateUrl: './group-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GroupIconComponent {}
